import { render, staticRenderFns } from "./ServiceBlockModal.vue?vue&type=template&id=27030490&"
import script from "./ServiceBlockModal.vue?vue&type=script&lang=js&"
export * from "./ServiceBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBlockModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports